import { domContentLoadEvent } from '../common/domContentLoadEvent';
import { closeModal, openModal } from '../common/simpleModal';

class ModalVideo {
    constructor() {
        this.modalSelector = '.modal-video';
        this.iframe = document.querySelector(`${this.modalSelector} iframe`);
        this.legendElement = document.querySelector(`${this.modalSelector} p`);
        this.closeButton = document.querySelector(`${this.modalSelector} .close-modal`);

        this.init();
    }

    init() {
        this.bindPlayButtons();
        this.bindCloseButton();
    }

    bindPlayButtons() {
        document.querySelectorAll('.btn-play').forEach(button => {
            button.addEventListener('click', (event) => this.openVideo(event));
        });
    }

    bindCloseButton() {
        if (this.closeButton) {
            this.closeButton.addEventListener('click', () => this.closeVideo());
        }
    }

    openVideo(event) {
        const button = event.currentTarget;
        const yid = button.getAttribute('data-yid');
        const legend = button.getAttribute('data-legend');

        if (this.iframe) {
            this.iframe.setAttribute('src', `https://www.youtube.com/embed/${yid}?rel=0`);
        }

        if (this.legendElement) {
            this.legendElement.innerHTML = legend;
        }

        openModal(this.modalSelector);
    }

    closeVideo() {
        if (this.iframe) {
            this.iframe.setAttribute('src', 'about:blank');
        }
        closeModal(this.modalSelector);
    }
}

domContentLoadEvent(() => new ModalVideo());